import { PageLayout } from "../components/PageLayout.js";

export function Explore() {
  return (
    <PageLayout title="Explore">
      <div className="card">
        <div className="muted">Coming soon.</div>
      </div>
    </PageLayout>
  );
}
